<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('class-attendance-report-for-admin.title') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('class-attendance-report-for-admin.title'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <!-- Wrap study time and session together -->
          <div class="d-flex">
            <div
              class="form-group d-flex flex-column mr-3"
              style="width: 250px; margin-left: 0;"
            >
              <label>
                {{ $t('class-attendance-report-for-admin.study_time') }}
              </label>
              <a-select
                v-model="model.ac_st_id"
                :options="studyTimeOptions"
                :placeholder="$t('all')"
                style="width: 250px"
                showSearch
                mode="multiple"
                :filterOption="
                  (input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                "
                :maxTagCount="1"
              />
            </div>
          </div>

          <!-- Right: search input + filter button -->
          <div class="d-flex align-items-center">
            <ts-input
              v-model="search"
              :placeholder="$t('class-attendance-report-for-admin.search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="() => (visible = false)"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <a-select
                  style="width: 257px"
                  v-model="branch_id"
                  :options="branchs"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                >
                </a-select>
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <Table
          :columns="columns"
          :data="resources"
          size="small"
          :loading="loading"
          max-height="500"
          ref="selection"
          stripe
        >
          <template slot-scope="{ row }" slot="submission_status">
            <span
              :class="[
                'badge',
                row.submission_status === 'Submitted'
                  ? 'badge-success'
                  : row.submission_status === 'Pending'
                  ? 'badge-default'
                  : row.submission_status === 'Re-Submitted'
                  ? 'badge-warning'
                  : ''
              ]"
            >
              {{ row.submission_status }}
            </span>
          </template>
        </Table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import expandRow from './table-expand.vue'
import { debounce } from 'lodash'
export default {
  name: 'classAttendaceReportIndex',
  data() {
    return {
      loadingFilter: false,
      loading: false,
      visible: false,
      studyTimeOptions: [],
      branch_id: [],
      branchs: [],
      model: {
        ac_st_id: [],
      }
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.getStudyTimeFilter()
    this.getBranch()
  },
  computed: {
    ...mapState('classAttendanceReport', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.classAttendanceReport.search
      },
      set(newValue) {
        this.$store.commit('classAttendanceReport/SET_SEARCH', newValue)
        this.$store.commit('classAttendanceReport/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          type: 'expand',
          render: (h, params) => {
            return h(expandRow, {
              props: {
                records: params.row.details
              },
              on: { cancel: this.fetchData }
            })
          },
          width: 30
        },
        {
          title: this.$t('class-attendance-report-for-admin.branchName'),
          key: 'branch_name',
          width: 250
        },
        {
          title: this.$t('class-attendance-report-for-admin.class_name'),
          key: 'class_name',
          width: 250
        },
        {
          title: this.$t('class-attendance-report-for-admin.study_time'),
          key: 'study_time',
          width: 250
        },
        {
          title: this.$t('class-attendance-report-for-admin.teacher_name'),
          key: 'teacher_name',
          width: 250
        },
        {
          title: this.$t('class-attendance-report-for-admin.teacher_phone'),
          key: 'teacher_phone',
          width: 250
        },
        {
          title: this.$t('class-attendance-report-for-admin.submission_status'),
          slot: 'submission_status',
          width: 250,
          align: 'center'
        },
        {
          title: this.$t('class-attendance-report-for-admin.total_present'),
          key: 'total_present',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('class-attendance-report-for-admin.total_absent'),
          key: 'total_absent',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('class-attendance-report-for-admin.grade_name'),
          key: 'grade_name',
          width: 250
        },
        {
          title: this.$t('class-attendance-report-for-admin.sub_program'),
          key: 'sub_program',
          width: 250
        },
        {
          title: this.$t('class-attendance-report-for-admin.main_program'),
          key: 'main_program',
          width: 250
        },
        {
          title: this.$t('class-attendance-report-for-admin.submitted_by'),
          key: 'submitted_by',
          width: 200,
          align: 'center'
        },
        {
          title: this.$t('class-attendance-report-for-admin.submitted_date'),
          key: 'submitted_date',
          width: 200,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    ...mapActions('classAttendanceReport', ['fetch', 'formViewModel']),
    async fetchData(attributes = {}) {
      this.loading = true
      return await this.fetch({
        branch_id: this.branch_id,
        ac_st_id: this.model.ac_st_id,
        page: this.pagination.currentPage,
        ...attributes
      })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getStudyTimeFilter() {
      return this.formViewModel({
        fnName: 'getStudyTime'
      }).then(response => {
        if (response.status === 200) {
          this.studyTimeOptions = response.data.data.getStudyTime.map(item => {
            return {
              value: item.ac_st_id,
              label: item.study_time
            }
          })
        } else {
          this.$message.error(response.data.message)
        }
      })
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500),
    branch_id: debounce(function() {
      this.fetchData()
    }, 500),
    'model.ac_st_id': debounce(function() {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('classAttendanceReport/RESET_STATE')
    next()
  }
}
</script>
